<template>
  <span class="iconfont" :class="icon" :style="{ fontSize: size + 'px', color: color }"></span>
</template>

<script setup lang="ts">
import { computed, toRefs } from 'vue'

interface OwnProps {
  icon: string
  size?: number | string
  color?: string
}

const props = withDefaults(defineProps<OwnProps>(), {
  size: 14,
  color: 'inherit'
})
</script>

<style scoped lang="scss">
</style>
